<template>
  <div class="reader-loading">
    <div class="loading-content">
      <div class="logo-container">
        <img
          src="@/assets/img/ekitabuLogo.png"
          alt="eKitabu"
          class="logo"
        >
      </div>

      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
        width="6"
        class="mb-6"
      />

      <h2 class="loading-title">
        {{ loadingMessage }}
      </h2>

      <p class="loading-subtitle">
        {{ $t('reader.preparingExperience') }}
      </p>
    </div>
  </div>
</template>

<script>
const MESSAGE_INTERVAL_MS = 2000;

export default {
  name: 'ReaderLoading',
  data() {
    return {
      messageIndex: 0,
      messageInterval: null,
    };
  },
  computed: {
    loadingMessage() {
      const messages = [
        this.$t('reader.loadingLibrary'),
        this.$t('reader.preparingReader'),
        this.$t('reader.almostReady'),
      ];
      return messages[this.messageIndex] || messages[0];
    },
  },
  mounted() {
    this.messageInterval = setInterval(() => {
      if (this.messageIndex < 2) {
        this.messageIndex++;
      } else {
        clearInterval(this.messageInterval);
      }
    }, MESSAGE_INTERVAL_MS);
  },
  beforeDestroy() {
    if (this.messageInterval) {
      clearInterval(this.messageInterval);
    }
  },
};
</script>

<style scoped>
.reader-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--v-lightestAccent-base) 0%, var(--v-lightAccent-base) 100%);
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 2rem;
  max-width: 500px;
}

.logo-container {
  margin-bottom: 2rem;
}

.logo {
  width: 120px;
  height: auto;
  opacity: 0.9;
}

.loading-title {
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: var(--v-primaryText-base);
}

.loading-subtitle {
  font-size: 1rem;
  color: var(--v-secondaryText-base);
  opacity: 0.7;
}
</style>
